<template>
  <div id="scrollTo">
    <div class="d-flex jc-center">
      <span class="dot-title">
        {{ $t("Cart.title") }}
      </span>
    </div>

    <div class="px-4 pb-15" style="max-height: 57rem; overflow-y: overlay">
      <div class="d-flex flex-column cart-text-normal mb-2">
        <div class="d-flex px-8">
          <div class="w-15 d-flex ai-center">
            <div class="mr-4">
              <v-btn icon @click="selectAll">
                <img
                  v-if="isSelectAll"
                  src="/assets/ic/select/ic_select_tick2.png"
                  alt=""
                />
                <img
                  v-else
                  src="/assets/ic/select/ic_select_checkbox.png"
                  alt=""
                />
              </v-btn>
            </div>
            <div>
              <span>
                {{ $t("cart.selectAll") }}
              </span>
            </div>
          </div>
          <div class="w-30 d-flex ai-center">
            <span>
              {{ $t("cart.tagName") }}
            </span>
          </div>
          <div class="w-15 d-flex jc-center ai-center">
            <span>
              {{ $t("cart.unitPrice") }}
            </span>
          </div>
          <div class="w-15 d-flex jc-center ai-center">
            <span>
              {{ $t("cart.amount") }}
            </span>
          </div>
          <div class="w-15 d-flex jc-center ai-center">
            <span>
              {{ $t("cart.price") }}
            </span>
          </div>
          <div class="w-10"></div>
        </div>
      </div>
      <v-expand-transition>
        <v-form
          ref="form"
          class="d-flex flex-column mb-2"
          v-if="!loading"
          v-model="formValid"
        >
          <div
            v-for="(item, idx) in cartAll"
            :key="'cartAll' + idx"
            class="mb-2"
          >
            <div class="d-flex px-8 cart-row">
              <div class="w-15 ai-center d-flex">
                <div class="mr-4 p-relative" style="margin-top: -2.2rem;">
                  <v-btn icon @click="selectItem(item, !item.selected)">
                    <img
                      v-if="item.selected"
                      src="/assets/ic/select/ic_select_tick2.png"
                      alt=""
                    />
                    <img
                      v-else
                      src="/assets/ic/select/ic_select_checkbox.png"
                      alt=""
                    />
                  </v-btn>
                </div>
                <v-hover v-slot:default="{ hover }">
                  <div
                    class="preview-img d-flex flex-column jc-between p-relative"
                  >
                    <div
                      class="p-absolute hover-img d-flex jc-center ai-center"
                      v-if="hover"
                    >
                      <v-img
                        :src="item.previewImg"
                        max-height="11.2rem"
                        contain
                      ></v-img>
                    </div>
                    <div class="flex-1">
                      <v-img
                        max-height="1.9rem"
                        :src="getStaticFileURL(item.tag.imgPath)"
                        contain
                        alt="previewImg"
                      ></v-img>
                    </div>
                    <div class="flex-1">
                      <v-img
                        max-height="1.9rem"
                        :src="item.previewImg"
                        contain
                        alt="tag_image"
                      ></v-img>
                    </div>
                  </div>
                </v-hover>
              </div>
              <div class="w-30 d-flex ai-center cart-text-normal">
                <span>{{ item.tag.name }}</span>
              </div>
              <div class="w-15 d-flex jc-center ai-center cart-text-weight">
                {{ unitPrice(item) }}
              </div>
              <div class="w-15 d-flex jc-center ai-center cart-text-weight">
                <v-text-field
                  class="px-5"
                  :min="minAmount(item)"
                  :max="maxAmount(item.tag)"
                  v-model.number="item.amount"
                  :disabled="item.selected"
                  autocomplete="off"
                  @input="item.error = ''"
                  :rules="[
                    value => !!value || $t('errorMessage.required'),
                    value =>
                      value >= minAmount(item) ||
                      $t('cart.amountLessThenMin', {
                        min: minAmount(item)
                      })
                  ]"
                ></v-text-field>
              </div>
              <div
                class="w-15 d-flex jc-center ai-center cart-text-weight text-red"
              >
                {{ numberToCurrency(rowPrice(item)) }}
              </div>
              <div class="w-10 d-flex jc-end pt-7">
                <v-btn @click="delOrderItem(idx)" text class="cart-text-normal">
                  {{ $t("cart.delete") }}
                </v-btn>
              </div>
            </div>
            <div v-if="item.error" class="text-red">
              {{ item.error }}
            </div>
          </div>
        </v-form>
      </v-expand-transition>
    </div>

    <div class="cart-footer w-100 d-flex ai-center">
      <div class="d-flex ml-6 ai-center">
        <span style="color: #999999; font-size: 0.85rem">
          {{
            $t("cart.shippingFeeText", {
              shipping: numberToCurrency(shippingFee.free)
            })
          }}
        </span>
      </div>
      <div class="flex-1 d-flex jc-end">
        <span
          class="d-flex ai-center"
          style="color: #999999;font-size: 0.85rem"
          v-if="isSelected"
        >
          {{
            $t("cart.priceAndShippingText", {
              price: numberToCurrency(totalPrice),
              shipping: numberToCurrency(shipping)
            })
          }}
        </span>
        <div class="d-flex ai-center mx-12" v-if="isSelected">
          <span style="color: #4a4a4a; font-size: 0.85rem">
            {{ $t("cart.total") }}
          </span>
          <span class="text-red fw-weight ml-2" style="font-size: 1.25rem">
            {{
              $t("cart.priceText", {
                price: numberToCurrency(totalPriceAddFee)
              })
            }}
          </span>
        </div>
      </div>
      <v-btn
        depressed
        tile
        color="orange"
        class="btn-checkout"
        :disabled="!isSelected"
        @click="nextStep"
      >
        {{ $t("cart.checkout") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      loading: true,
      cartAll: [],
      tag: {},
      shippingFee: {
        shipping: 0,
        free: 0
      },
      formValid: false
    };
  },
  computed: {
    ...mapState("cart", ["cart"]),
    ...mapState(["newOrder"]),
    locale() {
      if (this.$i18n.locale === "zh-TW") return "TW";
      else if (this.$i18n.locale === "zh-CN") return "CN";
      else if (this.$i18n.locale === "en") return "EN";
      return "TW";
    },
    isSelectAll() {
      return this.cartAll.every(item => item.selected);
    },
    isSelected() {
      return this.cartAll.some(item => item.selected);
    },
    totalPrice() {
      let price = 0;
      this.cartAll.forEach(item => {
        if (item.selected) price += this.rowPrice(item);
      });
      return Math.round(price);
    },
    totalPriceAddFee() {
      const free = this.totalPrice >= this.shippingFee.free;
      const total = this.totalPrice;
      return free ? total : total + this.shippingFee.shipping;
    },
    shipping() {
      const free = this.totalPrice >= this.shippingFee.free;
      return free ? 0 : this.shippingFee.shipping;
    }
  },
  methods: {
    ...mapActions("cart", ["getCart"]),
    ...mapMutations("newOrder", ["setConfirmItem", "clearOrder"]),
    ...mapActions("snackbar", ["openSnackbar"]),
    minAmount(item) {
      return Math.max(item.tag.minOrderQuantity, item.saleVolume);
    },
    maxAmount(tag) {
      return Math.min(tag.inventory);
    },
    unitPrice(item) {
      const amount = item.amount;
      const pr = item.tag.priceRanges;
      const len = item.tag.priceRanges.length;
      for (let i = 0; i < len; i++) {
        if (amount >= pr[i].interval) return pr[i].price;
      }
      return item.tag.priceRanges[len - 1].price;
    },
    rowPrice(item) {
      return item.amount * this.unitPrice(item);
    },
    numberToCurrency(value) {
      if (!value) return "0";
      return new Intl.NumberFormat().format(value);
    },
    async delOrderItem(idx) {
      const orderItemId = this.cartAll[idx].orderItemId;
      const confirm = await this.$root.$confirm({
        content: this.$t("cart.confirmDelOrderItem"),
        confirmBtn: true,
        cancelBtn: true
      });
      if (!confirm) return;
      const cartData = {
        orderItemIds: [orderItemId],
        inCart: false
      };
      await this.$http.put("orderItems/cart", cartData).then(() => {
        this.openSnackbar({
          msg: this.$t("cart.delFromCartSuccess"),
          color: "success"
        });
        this.cartAll.splice(idx, 1);
      });
    },
    validateNum(item) {
      console.log(item);
    },
    selectItem(item, status, isSelectAll) {
      if (!isSelectAll) {
        this.cartAll.forEach(item => {
          item.error = "";
        });
      }
      this.$refs.form.validate();
      const tag = this.tag[item.tagId];
      if (status === item.selected) return;
      const amount = parseInt(item.amount);
      if (item.selected) {
        tag.leftInventory += amount;
        item.selected = false;
        return;
      }
      if (amount < this.minAmount(item)) return;
      const left = parseInt(tag.leftInventory);
      if (left >= amount) {
        tag.leftInventory -= amount;
        item.selected = true;
        item.error = "";
      } else {
        item.error = this.$t("cart.amountGreaterThenInventory", {
          inventory: tag.leftInventory
        });
      }
    },
    selectAll() {
      const target = !this.isSelectAll;
      this.cartAll.forEach(item => {
        this.selectItem(item, target, true);
      });
    },
    nextStep() {
      const confirmItems = [];
      this.cartAll.forEach(item => {
        if (item.selected) {
          confirmItems.push({
            orderItemId: item.orderItemId,
            saleVolume: item.amount
          });
        }
      });
      this.setConfirmItem(confirmItems);
      this.$router.push(`/${this.$i18n.locale}/order/detail`);
    },
    initCart() {
      const back = this.$route.query.back === "true";
      if (!back) this.clearOrder();
      this.cartAll.forEach(item => {
        let amount =
          item.saleVolume === 0 ? item.tag.minOrderQuantity : item.saleVolume;
        let idx = -1;
        if (back) {
          idx = this.newOrder.confirmItems.findIndex(
            cItem => cItem.orderItemId === item.orderItemId
          );
          if (idx !== -1) {
            amount = this.newOrder.confirmItems[idx].saleVolume;
          }
        }
        this.$set(item, "selected", idx !== -1);
        this.$set(item, "amount", amount);
        this.$set(item, "tagId", item.tag.tagId);
        this.$set(item, "error", "");
        this.$set(this.tag, item.tag.tagId, item.tag);
        this.$set(
          this.tag[item.tag.tagId],
          "leftInventory",
          item.tag.inventory
        );
      });
      this.loading = false;
      if (back) this.$vuetify.goTo("#scrollTo", this.scrollOptions);
    }
  },
  async created() {
    await this.getCart();
    const res = await this.$http.get("shippingFees");
    this.shippingFee = res.data;
    this.cartAll = JSON.parse(JSON.stringify(this.cart));
    this.initCart();
  }
};
</script>

<style lang="sass" scoped>
.hide
  display: none !important
.dot-title
  padding-top: 2.2rem
  padding-bottom: 0.55rem
  margin-bottom: 4.75rem
  font-size: 2.75rem
  color: #ffa20a
  letter-spacing: 0.4585rem
  text-indent: 0.4585rem
  border-bottom: 2px dashed #ffa20a
.cart-text-normal
  font-size: 0.85rem
  color: #999999
.cart-text-weight
  font-size: 1.25rem
  font-weight: bold
  color: #4a4a4a
  &.text-red
    color: #ff6868
.cart-row
  position: relative
  box-sizing: border-box
  border: 1px solid #DCDCDC
  height: 6rem
  &:before
    content: ""
    background: #FFA20A
    position: absolute
    left: 0
    top: 0
    width: 0.25rem
    height: 100%
    background: #ffa20a

::v-deep .v-text-field
  input
    font-size: 1.25rem
    text-align: center
    //padding-left: 0.7rem

.preview-img
  width: 4.5rem
  height: 4.5rem
  background: #f8f8f8
  border-radius: 0.3rem
  padding: 5px

.hover-img
  top: -2.5rem
  right: -13rem
  width: 12rem
  height: 12rem
  z-index: 10
  background: #f8f8f8
  border-radius: 0.3rem
  padding: 0.4rem


.cart-footer
  background: #E6E6E6
  height: 3.1rem
  position: absolute
  bottom: 0
  .btn-checkout
    color: white
    height: 100%
    width: 7.9rem
</style>
